import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { beforeAfterSection } from '../data/copy';
export function BeforeAfterSection() {
  return <section className="border-y border-white/10 bg-pf-navy px-3 py-3 text-white sm:px-4 sm:py-4" data-id="element-21" data-mp="by8e8mp9f89o">
      <div className="mx-auto max-w-4xl" data-id="element-22" data-mp="ppvesyq8j2y9">
        <h2 className="text-center font-display text-xl font-extrabold uppercase leading-tight tracking-tight text-white sm:text-4xl" data-id="element-23" data-mp="kwk3akah9y00">
          {beforeAfterSection.title}
        </h2>
        <p className="mb-1.5 text-center text-[12.5px] font-medium text-white/75 sm:text-base" data-id="element-24" data-mp="un5ct2rowmxp">
          {beforeAfterSection.intro}
        </p>

        <div className="grid gap-1.5 sm:grid-cols-2 sm:gap-2" data-id="element-25" data-mp="18ld7f4197c5p">
          <div className="rounded-lg border border-white/15 bg-white/5 p-2.5 sm:p-3" data-id="element-26" data-mp="13n1vmnreerku">
            <h3 className="mb-1 font-display text-[13px] font-extrabold uppercase text-white sm:text-lg" data-id="element-27" data-mp="3adrjvnl13oeq">
              Today:
            </h3>
            <ul className="space-y-0.5" data-id="element-28" data-mp="35g84ulgib7lq">
              {beforeAfterSection.today.map(item => <li key={item} className="flex items-start gap-1.5 text-[12px] font-medium leading-snug text-white/80 sm:text-sm" data-id="element-29" data-mp="36pulf6f4fo3n">
                  <XIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-pf-coral" aria-hidden="true" data-id="element-30" data-mp="3glo8hjqguzzo" />
                  {item}
                </li>)}
            </ul>
          </div>
          <div className="rounded-lg border border-pf-gold/60 bg-white/10 p-2.5 sm:p-3" data-id="element-31" data-mp="3pfsspkb3hd68">
            <h3 className="mb-1 font-display text-[13px] font-extrabold uppercase text-pf-gold sm:text-lg" data-id="element-32" data-mp="3udkvj9da2jp7">
              Tomorrow:
            </h3>
            <ul className="space-y-0.5" data-id="element-33" data-mp="38ks0vb4dugj">
              {beforeAfterSection.tomorrow.map(item => <li key={item} className="flex items-start gap-1.5 text-[12px] font-bold leading-snug text-white sm:text-sm" data-id="element-34" data-mp="84tgizb7j00d">
                  <CheckIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-pf-gold" aria-hidden="true" data-id="element-35" data-mp="29ysq9g8ol9ay" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mt-1.5 text-center" data-id="element-36" data-mp="2bwacwwoxtj3c">
          <p className="font-display text-[14px] font-extrabold uppercase text-white sm:text-xl" data-id="element-37" data-mp="2bx27q5apncsk">
            {beforeAfterSection.close[0]}
          </p>
          <p className="text-[12.5px] font-medium text-white/80 sm:text-base" data-id="element-38" data-mp="2kvnlzo95g5nj">
            {beforeAfterSection.close[1]}
          </p>
        </div>
      </div>
    </section>;
}